var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { isFunction } from '../_internal/data';
import { linkStyle } from '../Link/Link.style';
import { titleStyles } from '../Title/Title.style';
import { getHTMLFromMarkdown } from './withMarkdown.utils';
export var withMarkdown = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.inline, inline = _c === void 0 ? false : _c;
    return function (WrappedComponent) {
        var StyledComponent = styled(WrappedComponent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    & p {\n      &:not(:first-child) {\n        margin-top: 12px;\n      }\n\n      &:not(:last-child) {\n        margin-bottom: 12px;\n      }\n    }\n\n    & h2 {\n      ", ";\n    }\n\n    & h3 {\n      ", ";\n\n      &:not(:first-child) {\n        margin-top: 48px;\n      }\n    }\n\n    & h4 {\n      ", ";\n\n      &:not(:first-child) {\n        margin-top: 24px;\n      }\n    }\n\n    & strong {\n      font-weight: 600;\n    }\n\n    & a {\n      ", ";\n    }\n\n    & ul {\n      list-style-type: none;\n      padding-inline-start: 0;\n    }\n\n    & li {\n      position: relative;\n      display: block;\n      padding-left: 0.8em;\n\n      &:first-letter {\n        text-transform: capitalize;\n      }\n\n      &::after {\n        content: '\u2022';\n        position: absolute;\n        left: 0;\n        top: 0;\n      }\n    }\n  "], ["\n    & p {\n      &:not(:first-child) {\n        margin-top: 12px;\n      }\n\n      &:not(:last-child) {\n        margin-bottom: 12px;\n      }\n    }\n\n    & h2 {\n      ", ";\n    }\n\n    & h3 {\n      ", ";\n\n      &:not(:first-child) {\n        margin-top: 48px;\n      }\n    }\n\n    & h4 {\n      ", ";\n\n      &:not(:first-child) {\n        margin-top: 24px;\n      }\n    }\n\n    & strong {\n      font-weight: 600;\n    }\n\n    & a {\n      ", ";\n    }\n\n    & ul {\n      list-style-type: none;\n      padding-inline-start: 0;\n    }\n\n    & li {\n      position: relative;\n      display: block;\n      padding-left: 0.8em;\n\n      &:first-letter {\n        text-transform: capitalize;\n      }\n\n      &::after {\n        content: '\u2022';\n        position: absolute;\n        left: 0;\n        top: 0;\n      }\n    }\n  "])), titleStyles.headerSmall, titleStyles.section, titleStyles.regular, linkStyle);
        var Component = React.forwardRef(function (props, ref) {
            var markdown = props.markdown, children = props.children, rest = __rest(props, ["markdown", "children"]);
            if (!markdown) {
                return (React.createElement(WrappedComponent, __assign({ ref: ref }, rest), children));
            }
            var isInline = isFunction(inline) ? inline(props) : !!inline;
            return (React.createElement(StyledComponent, __assign({ ref: ref }, rest, { "data-markdown": true, dangerouslySetInnerHTML: {
                    __html: getHTMLFromMarkdown({
                        children: children,
                        inline: isInline,
                    }),
                } })));
        });
        return Component;
    };
};
var templateObject_1;
//# sourceMappingURL=withMarkdown.js.map